var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupplierChange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.4 81.2H43.6V56.5L56.4 57V81.2Z",
    fill: "#5A87FF",
    stroke: "#5A87FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66 31.2C63.9 31.3 61.6 31.4 59.3 31.5C59.2 27.7 59.1 22.2 59.1 18.3V17.8H59.6L66 17.9H66.4C66.4 22.4 66.1 26.9 66 31.2ZM66 31.2C65.9 27.4 65.6 22 65.6 18.3L66 18.7L59.6 18.8L60.1 18.3C60.1 22.1 60 27.4 59.9 31.2L59.6 30.9C61.6 31 63.7 31.2 66 31.2Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6 46.8L18.3 47.7L27.5 25.8L72.4 26.8L81.6 46.8Z",
    fill: "#FF4F40",
    stroke: "#FF4F40",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7 47.9C82 55.8 82.2 63.7 81.9 71.7C81.7 74.7 81.7 77.7 80.9 80.7C80.8 81 80.7 81.3 80.4 81.6C80.2 81.9 79.6 82 79.2 82.1C74.7 82.6 70.2 82.5 65.7 82.6C50 82.7 34.1 82.5 18.3 82H17.5V81.2C17.6 72.7 17.9 64.3 18.3 55.8C18.7 64.3 18.9 72.7 19.1 81.2L18.3 80.4C28.4 80.3 69.8 81 79 80.5C79.2 80.5 79.5 80.4 79.2 80.5C79.2 80.5 79.3 80.3 79.4 80.1C80.2 77.4 80.3 74.4 80.6 71.5C81.2 63.7 81.5 55.8 81.7 47.9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupplierChange);
export default __webpack_public_path__ + "static/media/supplier-change.b8ad384f0c374eba1f78b741059dde23.svg";
export { ForwardRef as ReactComponent };